import React, { useState, useEffect } from 'react';
// Import images
import image_1 from "../assests/homepage_image_2.jpg";
import image_2 from "../assests/homepage_image_3.jpg";
import image_3 from "../assests/homepage_image_5.jpg";
import image_4 from "../assests/homepage_image_14.jpg";
import image_6 from "../assests/homepage_image_15.jpg";
import image_5 from "../assests/homepage_image_6.jpg";

const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Array of images with title and description
  const images = [
    { id: 1, src: image_2, alt: "Homepage Image 2", title: "Mission Control Software for CubeSat", description: "Mission Control Software (MCS) provides an easy-to-use monitoring and control access to any space mission." },
    { id: 2, src: image_1, alt: "Homepage Image 3", title: "Software defined Radio for Cubesat", description: "Sensing and Communication Applications using powerful and advanced FPGA Technology CubeSats have revolutionized the way scientific community perceive space." },
    { 
      id: 3, 
      src: image_3, // Desktop image
      mobileSrc: image_5, // Mobile image
      alt: "Homepage Image 5", 
      title: "RiGEL UCAV On SWaP Platform", 
      description: "The nation moves into a new era of defence through unparalleled intelligence, surveillance, and reconnaissance (ISR)." 
    },
    { 
      id: 4, 
      src: image_4, // Desktop image
      mobileSrc: image_6, // Mobile image
      alt: "Homepage Image 4", 
      title: "Agastya: A DNN Robot", 
      description: "Agastya, an AI robot built on over a decade of DNN research, revolutionizes space security with autonomous drone and aircraft swarms operating without GPS, communication, or pilots." 
    }
    // { id: 4, src: image_4, alt: "Homepage Image 4", title: "Agastya: A DNN Robot", description: "Agastya, an AI robot built on over a decade of DNN research, revolutionizes space security with autonomous drone and aircraft swarms operating without GPS, communication, or pilots." }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const formatTitle = (title) => {
    const words = title.split(' ');
    return (
      <>
        {words.slice(0, 2).join(' ')}{' '}
        {words[2] && <span className="text-yellow-400">{words[2]}</span>}{' '}
        {words[3] && <span className="text-yellow-400">{words[3]}</span>}{' '}
        {words.slice(4).join(' ')}
      </>
    );
  };

  return (
    <div className="w-full relative">
      {/* Progress bar */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gray-200">
        <div className="h-full bg-blue-600 transition-all duration-[10000ms] ease-linear" style={{ width: '100%', animation: 'progress 10s linear infinite' }} />
      </div>
      {/* Image container */}
      <div className="relative w-full h-[650px]">
        {images.map((image, index) => (
          <div
            key={image.id}
            className={`absolute top-0 left-0 w-full h-full transition-opacity duration-500 flex items-center justify-center ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {(image.id === 3 || image.id === 4) ? (
              <>
                <img 
                  src={image.mobileSrc} 
                  alt={image.alt} 
                  className="w-full h-full object-cover sm:hidden" 
                />
                <img 
                  src={image.src} 
                  alt={image.alt} 
                  className="hidden sm:block w-full h-full object-cover" 
                />
              </>
            ) : (
              <img 
                src={image.src} 
                alt={image.alt} 
                className="w-full h-full object-cover" 
              />
            )}
            {/* Overlay content */}
            <div className="absolute left-4 2xl:top-44 text-white pl-4 rounded-lg max-w-lg space-y-4 sm:left-16 md:left-20 lg:left-20 xl:left-20 2xl:left-20">
              <h2 className="text-5xl font-bold font-nova-square">{formatTitle(image.title)}</h2>
              <p className="text-xl">{image.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Navigation dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full ${index === currentIndex ? 'bg-white' : 'bg-white/50'}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
      <style jsx>{`
        @keyframes progress {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}</style>
    </div>
  );
};

export default ImageCarousel;